module.exports = __webpack_public_path__ + "img/img-card-2.12378b5.webp";